module.exports = __webpack_public_path__ + "static/media/Straight Away.bda95892.png";